"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "GridColumnsService", {
    enumerable: true,
    get: function() {
        return GridColumnsService;
    }
});
const _common = require("@nestjs/common");
const _nocodbsdk = require("nocodb-sdk");
const _viewwebhookmanager = require("~/utils/view-webhook-manager");
const _cli = require("~/cli");
const _NocoCache = /*#__PURE__*/ _interop_require_default(require("~/cache/NocoCache"));
const _globals = require("~/utils/globals");
const _apphooksservice = require("~/services/app-hooks/app-hooks.service");
const _helpers = require("~/helpers");
const _models = require("~/models");
const _extractProps = require("~/helpers/extractProps");
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
const _NocoSocket = /*#__PURE__*/ _interop_require_default(require("~/socket/NocoSocket"));
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
let GridColumnsService = class GridColumnsService {
    async columnList(context, param, ncMeta) {
        return await _models.GridViewColumn.list(context, param.gridViewId, ncMeta);
    }
    async gridColumnUpdate(context, param, ncMeta) {
        var _param_viewWebhookManager;
        (0, _helpers.validatePayload)('swagger.json#/components/schemas/GridColumnReq', param.grid);
        const oldGridViewColumn = await _models.GridViewColumn.get(context, param.gridViewColumnId, ncMeta);
        const column = await _models.Column.get(context, {
            colId: oldGridViewColumn.fk_column_id
        }, ncMeta);
        const view = await _models.View.get(context, oldGridViewColumn.fk_view_id, ncMeta);
        const viewWebhookManager = (_param_viewWebhookManager = param.viewWebhookManager) != null ? _param_viewWebhookManager : (await (await new _viewwebhookmanager.ViewWebhookManagerBuilder(context, ncMeta).withModelId(view.fk_model_id)).withViewId(view.id)).forUpdate();
        const res = await _models.GridViewColumn.update(context, param.gridViewColumnId, param.grid, ncMeta);
        const viewColumn = (0, _extractProps.extractProps)(param.grid, [
            'order',
            'show',
            'width',
            'group_by',
            'group_by_order',
            'group_by_sort',
            'aggregation'
        ]);
        this.appHooksService.emit(_nocodbsdk.AppEvents.VIEW_COLUMN_UPDATE, {
            oldViewColumn: oldGridViewColumn,
            // todo: improve and move it to one place rather than repetition
            viewColumn,
            column,
            view,
            req: param.req,
            context
        });
        _NocoSocket.default.broadcastEvent(context, {
            event: _nocodbsdk.EventType.META_EVENT,
            payload: {
                action: 'view_column_update',
                payload: _extends({}, oldGridViewColumn, viewColumn)
            }
        }, context.socket_id);
        if (!param.viewWebhookManager) {
            (await viewWebhookManager.withNewViewId(view.id)).emit();
        }
        return res;
    }
    async gridColumnClearGroupBy(context, param, ncMeta = _Noco.default.ncMeta) {
        const qb = ncMeta.knex(_cli.MetaTable.GRID_VIEW_COLUMNS).where('base_id', '=', context.base_id).andWhere('fk_view_id', '=', param.viewId).update({
            group_by: null,
            group_by_order: null,
            group_by_sort: null,
            aggregation: 'none'
        });
        if (context.workspace_id) {
            qb.andWhere('fk_workspace_id', '=', context.workspace_id);
        }
        let viewWebhookManager;
        if (!param.viewWebhookManager) {
            var _param_viewWebhookManager;
            const view = await _models.View.get(context, param.viewId, ncMeta);
            viewWebhookManager = (_param_viewWebhookManager = param.viewWebhookManager) != null ? _param_viewWebhookManager : (await (await new _viewwebhookmanager.ViewWebhookManagerBuilder(context, ncMeta).withModelId(view.fk_model_id)).withViewId(view.id)).forUpdate();
        }
        await _NocoCache.default.deepDel(context, `${_globals.CacheScope.GRID_VIEW_COLUMN}:${param.viewId}`, _globals.CacheDelDirection.PARENT_TO_CHILD);
        const result = await qb;
        if (viewWebhookManager) {
            (await viewWebhookManager.withNewViewId(viewWebhookManager.getViewId())).emit();
        }
        return result;
    }
    constructor(appHooksService){
        this.appHooksService = appHooksService;
    }
};
GridColumnsService = _ts_decorate([
    (0, _common.Injectable)(),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _apphooksservice.AppHooksService === "undefined" ? Object : _apphooksservice.AppHooksService
    ])
], GridColumnsService);
